import { Fragment, memo } from "react";

import { CollectionContentCard } from "@components/CollectionContentCard";
import { ProductCard, ProductCardPlaceholder } from "@components/ProductCard";
import {
  type CollectionContentCard as CollectionContentCardType,
  type OPProductConnection,
} from "@root/tablescape/state";
import { tw } from "classnames";

type Props = {
  contentCards: Array<{
    contentCard: CollectionContentCardType;
    id: string;
    position: string;
  }> | null;
  isLoadingMore: boolean;
  nextLabel: string;
  prevLabel: string;
  productResults: Array<OPProductConnection>;
  showContentCards: boolean;
};

const styles = {
  base: tw(
    "m-0",
    "grid",
    "list-none",
    "grid-flow-row-dense",
    "grid-cols-2",
    "gap-x-4",
    "gap-y-10",
    "p-0",
    "md:grid-flow-row",
    "md:gap-x-6",
    "md:gap-y-12",
    "mg:grid-cols-3",
    "pb-15"
  ),
};

const CollectionGridViewBase = ({
  contentCards,
  isLoadingMore,
  nextLabel,
  prevLabel,
  productResults,
  showContentCards,
}: Props) => {
  return (
    <ol className={styles.base}>
      {showContentCards
        ? productResults?.map((product, index) => {
            const contentCard = contentCards?.find(
              (card) => parseInt(card.position, 10) === index
            );

            return (
              <Fragment key={`productCard-${product.id}`}>
                <ProductCard
                  nextLabel={nextLabel}
                  prevLabel={prevLabel}
                  product={product}
                />
                {contentCard && (
                  <CollectionContentCard {...contentCard.contentCard} />
                )}
              </Fragment>
            );
          }) ?? []
        : productResults?.map((product) => (
            <ProductCard
              key={`productCard_${product.id}`}
              nextLabel={nextLabel}
              prevLabel={prevLabel}
              product={product}
            />
          ))}
      {isLoadingMore &&
        Array.from({ length: 6 }).map((_, index) => (
          <ProductCardPlaceholder key={`placeholder-productCard-${index}`} />
        ))}
    </ol>
  );
};

export const CollectionGridView = memo(CollectionGridViewBase);
